import React from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import BeforeLoginHeader from '@/components/layout-new/before-login/Header';
import { HEADER_ID } from '@/constants/component-id';
import { AuthContext } from '@/context/create-context';

gsap.registerPlugin(useGSAP);

const Header = (props: { isHideHeader?: boolean }) => {
  const { isHideHeader = false } = props;
  const [hideHeader, setHideHeader] = React.useState(isHideHeader);

  const { user } = React.useContext(AuthContext);

  React.useEffect(() => {
    if (isHideHeader && user) {
      setHideHeader(false);
    }
  }, [user]);

  useGSAP(() => {
    if (isHideHeader && !hideHeader) {
      gsap.set(`#${HEADER_ID}`, { display: 'flex' });
      gsap.from(`#${HEADER_ID}`, {
        opacity: 0,
        duration: 0.3,
        ease: 'power1.inOut',
      });
    }
  }, [hideHeader]);

  if (hideHeader) {
    return null;
  }

  return <BeforeLoginHeader isSalaryLink={true} isHideHeader={isHideHeader} />;
};

export default Header;
